export const PROCESSING = 'app/Main/processing';
export const GET_CLIENT_DETAILS = 'app/Main/GET_CLIENT_DETAILS';
export const GET_CLIENT_DETAILS_SUCCESS = 'app/Main/GET_CLIENT_DETAILS_SUCCESS';
export const GET_CLIENT_DETAILS_FAIL = 'app/Main/GET_CLIENT_DETAILS_FAIL';
export const SHOW_TERMS_OF_USE = 'app/Main/SHOW_TERMS_OF_USE';
export const SHOW_PRIVACY_POLICY = 'app/Main/SHOW_PRIVACY_POLICY';
export const SHOW_FEEDBACK = 'app/Main/SHOW_FEEDBACK';
export const GET_FOOTER = 'app/Main/GET_FOOTER';
export const GET_FOOTER_SUCCESS = 'app/Main/GET_FOOTER_SUCCESS';
export const GET_HOME_HERO = 'app/Main/GET_HOME_HERO';
export const GET_HOME_HERO_SUCCESS = 'app/Main/GET_HOME_HERO_SUCCESS';
export const SEND_MAIL = 'app/Main/SEND_MAIL';
export const SEND_MAIL_SUCCESS = 'app/Main/SEND_MAIL_SUCCESS';
export const GET_HOME_HEADERS = 'app/Main/GET_HOME_HEADERS';
export const GET_HOME_HEADERS_SUCCESS = 'app/Main/GET_HOME_HEADERS_SUCCESS';
export const GET_FAVORITES_HEADERS = 'app/Main/GET_FAVORITES_HEADERS';
export const GET_FAVORITES_HEADERS_SUCCESS =
  'app/Main/GET_FAVORITES_HEADERS_SUCCESS';
export const GET_SITE_COPY = 'app/Main/GET_SITE_COPY';
export const GET_SITE_COPY_SUCCESS = 'app/Main/GET_SITE_COPY_SUCCESS';
export const CLIENT_DETAILS_FETCHING = 'app/Main/CLIENT_DETAILS_FETCHING';
export const GET_PROGRAMS_BY_TOPIC = 'app/Main/GET_PROGRAMS_BY_TOPIC';
export const GET_PROGRAMS_BY_TOPIC_SUCCESS =
  'app/Main/GET_PROGRAMS_BY_TOPIC_SUCCESS';
export const GET_THEMES = 'app/Main/GET_THEMES';
export const GET_THEMES_SUCCESS = 'app/Main/GET_THEMES_SUCCESS';
export const GET_RESOURCES_COUNT_BY_TOPIC =
  'app/Main/GET_RESOURCES_COUNT_BY_TOPIC';
export const GET_RESOURCES_COUNT_BY_TOPIC_SUCCESS =
  'app/Main/GET_RESOURCES_COUNT_BY_TOPIC_SUCCESS';
export const GET_CLIENT_RESOURCES = 'app/Main/GET_CLIENT_RESOURCES';
export const GET_CLIENT_RESOURCES_SUCCESS =
  'app/Main/GET_CLIENT_RESOURCES_SUCCESS';
export const SHOW_REGION_SELECTOR = 'app/Main/SHOW_MAIN_SELECTOR';
export const SET_REGION = 'app/Main/SET_REGION';
export const UPDATE_BRAND = 'app/Main/UPDATE_BRAND';
export const SHOW_REGION_BANNER = 'app/Main/SHOW_REGION_BANNER';
export const CLEAR_CLIENT_DETAILS = 'app/Main/CLEAR_CLIENT_DETAILS';
export const SET_LANDING = 'app/Main/SET_LANDING';
export const SHOW_HOMEPAGE_PRO = 'app/Main/SHOW_HOMEPAGE_PRO';
